// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"call-off"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5.2983 13.7017C5.20928 13.5713 5.12184 13.4398 5.03601 13.3071C3.11515 10.3382 2 6.79932 2 3H8.77778L9.97148 8.37167L7.94713 10.396L8.12978 10.706M7.56494 16.4349C8.51345 17.3834 9.56179 18.2321 10.6928 18.9638C13.6618 20.8847 17.2006 21.9998 21 21.9998V15.2221L15.6283 14.0284L13.604 16.0527C12.4249 15.3832 11.3454 14.5585 10.3934 13.6064","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M21 3L3 21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CallOffIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'call-off',
    ref,
    icon: element,
  },
));

CallOffIcon.displayName = 'CallOffIcon';

export default CallOffIcon;
